
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import BtnCheck from "@/components/scope/btn-check.vue";
import { priceRulesEl, partsQuantityRules } from "@common/src/utils/verify";
import { InjectFunction } from "@common/src/utils/decorator";
import MyCheckbox from "@common/src/components/scope/my-checkbox/index.vue";
import t from "@common/src/i18n/t";
const staff = namespace("staff");
const parts = namespace("parts");
const user = namespace("user");
const app = namespace("app");
const inventory = namespace("inventory");
const setting = namespace("setting");
const common_base = namespace("common_base");
const common_inventory = namespace("common_inventory");

@InjectFunction("dayjs", "addCurrencyUnit", "emptyToLine", "splitThousands", "permit")
@Component({
  components: { BtnCheck, MyCheckbox }
})
export default class OutWarehouseEdit extends Vue {
  @setting.State serviceMode;
  @app.Mutation setPBPX;
  @staff.Action getStaffList;
  @parts.Action getPartsList;
  @inventory.Action queryPartsQtyByWarehouseTree;
  @user.State userData;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @common_base.State showPlatformParts;
  @common_inventory.Action queryTransferWarehouseDetail;
  @common_inventory.Action createTransferWarehouse;
  @common_inventory.Action updateTransferWarehouse;
  get breadData() {
    return [
      { name: t("v210.warehouse-transfer-management"), path: "/inventory/transfer-warehouse-list" },
      { name: this.isAdd ? t("v210.new-stock-transfer-doc") : t("v210.edit-stock-transfer-doc") }
    ];
  }
  get isAdd() {
    return this.$route.name === "TransferWarehouseAdd";
  }
  orderFormDataRules = {
    outboundType: [{ required: true, message: t("v210801.pls-select-outbound-type"), trigger: "change" }]
  };
  warehousePartsMap: any = {};
  handleWarehouseChange(row, prop, type = "manual") {
    // type: init manual
    if (prop === "warehouse") {
      let seletedWarehouse = row.list.find(item => row.fromWarehouseCode === item.warehouseCode);
      let tempArr = [];
      this.orderFormData.itemList.forEach(item => {
        if (item.partsCode === row.partsCode) {
          item.warehouseCode && tempArr.push(item.warehouseCode);
        }
      });
      this.warehousePartsMap[row.partsCode] = tempArr;
      row.shelfList = seletedWarehouse && seletedWarehouse.shelfList;
      if (type === "manual") {
        row.fromWarehouseShelfCode = "";
      }
      this.updateShelfEnableMap();
    } else {
      // 目标仓库change
      let seletedWarehouse = row.list.find(item => row.toWarehouseCode === item.warehouseCode);
      if (type === "manual") {
        row.toWarehouseShelfCode = "";
      }
      row.toShelfList = seletedWarehouse && seletedWarehouse.shelfList;
    }
  }
  checkPrice(rule, value, callback) {
    if (!value) {
      callback();
    } else {
      priceRulesEl(value, callback);
    }
  }
  advisorList: any = [];
  orderFormData: any = {
    transferStaffUserCode: "",
    remark: "",
    itemList: [],
    immediatelyTransfer: false // 是否立即转移
  };
  definitionPartsData: any = {
    partsInfo: {},
    amount: "",
    qty: "",
    totalInventory: 0,
    partsCode: "",
    fromWarehouseCode: "",
    fromWarehouseShelfCode: "",
    shelfList: [],
    toWarehouseCode: "",
    toWarehouseShelfCode: "",
    toShelfList: [],
    remark: "",
    list: [],
    manual: true
  };

  partsList: any[] = [];
  get transferCode() {
    return this.$route.params.id;
  }
  created() {
    this.setPBPX(52);
    this.init();
    this.handleAddParts(); // 默认添加第一行
  }
  async init() {
    await this.getStaffList({
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.advisorList = data.data.list;
    });
    if (!this.isAdd) {
      await this.getPartsLists();
      this.queryTransferWarehouseDetail({
        transferCode: this.transferCode
      }).then(async data => {
        data.data.itemList.forEach(item => {
          if (
            !this.partsList.some(partsItem => {
              return partsItem.partsCode === item.partsCode;
            })
          ) {
            this.partsList.push({
              partsCode: item.partsCode,
              partsName: item.partsName
            });
          }
        });
        for (let index = 0; index < data.data.itemList.length; index++) {
          let item = data.data.itemList[index];
          this.handleChooseParts(item.partsCode, index, item, "init");
        }
        this.orderFormData = data.data;
      });
    } else {
      this.getPartsLists("");
      this.orderFormData.transferStaffUserCode = this.userData.userCode;
    }
  }
  getPartsLists(name = "") {
    return this.getPartsList({
      pageNum: 1,
      pageSize: 20,
      searchKey: name,
      notOpadmin: this.showPlatformParts ? "0" : "1"
    }).then(data => {
      this.partsList = this.$safeValue(data, "data.list", []);
    });
  }

  computedTotalAmount() {
    const partsTotal = this.orderFormData.itemList.reduce((preV, curV) => preV + Number(curV.amount), 0);
    console.log(partsTotal);
    if (Object.is(NaN, partsTotal)) {
      return this.$message.error(t("setting.enter-quantity-or-amount"));
    }
    console.log(partsTotal);
    this.orderFormData.costAmount = partsTotal.toFixed(2);
  }
  handleChooseParts(val, index, row, type = "manual") {
    if (!this.shelfPartsMap[val]) {
      this.shelfPartsMap[val] = [];
    }
    return this.queryPartsQtyByWarehouseTree({
      partsCode: val
    }).then(data => {
      const warehouseList = this.$safeValue(data, "data.warehouseList", []);
      const partsInfo = warehouseList[0];
      let partsData = Object.assign(
        {},
        row,
        {
          partsCode: val,
          partsInfo: partsInfo,
          list: warehouseList,
          totalInventory: data.data.inventoryQty
        },
        { showQtyTips: false, showWarehouseTips: false }
      );

      if (type === "init") {
        this.handleWarehouseChange(partsData, "warehouse", type);
        this.handleWarehouseChange(partsData, "targetWarehouse", type);
      } else {
        partsData.fromWarehouseCode = "";
        partsData.fromWarehouseShelfCode = "";
        partsData.toWarehouseCode = "";
        partsData.toWarehouseShelfCode = "";
        partsData.qty = "";
      }
      this.orderFormData.itemList.splice(index, 1, partsData);
    });
  }

  checkAddData(): boolean {
    if (this.orderFormData.itemList.length < 1) {
      this.$message.error(t("setting.add-least-one-component"));
      return false;
    }
    for (let index = 0; index < this.orderFormData.itemList.length; index++) {
      const element = this.orderFormData.itemList[index];
      if (!element.partsCode) {
        this.$message.error(t("v210.please-select-the-parts-to-be-transferred-first"));
        return false;
      }
      if (!element.qty) {
        this.$message.error(t("v210.please-fill-in-the-transfer-quantity"));
        return false;
      }
      const checkPartsQty = partsQuantityRules(element.qty);
      if (!checkPartsQty.success) {
        this.$message.error(checkPartsQty.msg);
        return false;
      }
      if (
        !element.fromWarehouseCode ||
        !element.fromWarehouseShelfCode ||
        !element.toWarehouseCode ||
        !element.toWarehouseShelfCode
      ) {
        this.$message.error(t("v210.please-select-warehouse-/-location"));
        return false;
      }
    }
    return true;
  }
  operationName: string = "";

  handleSaveTransferWarehouse() {
    if (this.isAdd) {
      this.operationName = "add";
    } else {
      this.operationName = "edit";
    }
    this.emitSaveOutWarehouse();
  }
  emitSaveOutWarehouse() {
    (this.$refs["transferFormRef"] as any).validate(valid => {
      if (valid && this.checkAddData()) {
        this.btnStartLoading();
        const saveFunc = this.isAdd ? this.createTransferWarehouse : this.updateTransferWarehouse;
        this.orderFormData.immediatelyTransfer = this.operationName === "confirm";
        this.btnStartLoading();
        saveFunc(this.orderFormData)
          .then(data => {
            if (this.operationName === "add" || this.operationName === "edit") {
              this.$message.success(t("v210.stock-transfer-order-saved"));
            } else if (this.operationName === "confirm") {
              this.$message.success(t("v210.stock-transfer-doc-moved"));
              this.showInConfirmTips = false;
            }
            this.$router.push(`/inventory/transfer-warehouse-view/${data.data.transferCode}`);
          })
          .finally(() => {
            this.btnStopLoading();
          });
      } else {
        console.log("error submit!!");
      }
    });
  }
  handleAddParts() {
    this.orderFormData.itemList.push(Object.assign({}, this.definitionPartsData));
  }
  deleteItem(key, index) {
    this.orderFormData[key].splice(index, 1);
    this.updateShelfEnableMap();
  }
  handleShelfSelectFocus(row, type) {
    if (type === "warehouse") {
      if (!row.fromWarehouseCode) {
        this.$message.error(t("v210.please-select-the-original-warehouse-first"));
      }
    } else {
      if (!row.toWarehouseCode) {
        this.$message.error(t("v210.please-select-the-target-warehouse-first"));
      }
    }
  }
  handleOpPartsShowChange() {
    this.getPartsLists();
  }
  showInConfirmTips: boolean = false;
  handleShowConfirmDialog() {
    this.showInConfirmTips = true;
  }
  handleConfirmTransfer() {
    this.operationName = "confirm";
    this.emitSaveOutWarehouse();
  }
  shelfPartsMap: any = {};
  handleShelfChange() {
    this.updateShelfEnableMap();
  }
  checkShelfEnable(partsRow, shelfRow) {
    return (
      this.shelfPartsMap[partsRow.partsCode].includes(shelfRow.shelfCode) && partsRow.shelfCode !== shelfRow.shelfCode
    );
  }
  // 当仓库和库位发生变化更新零配件和库位的映射，即同一个零配件和相同库位只能存在一行
  updateShelfEnableMap() {
    let tempMap = {};
    this.orderFormData.itemList.forEach(item => {
      let curShelfCode = item.fromWarehouseShelfCode;
      if (!tempMap[item.partsCode]) {
        tempMap[item.partsCode] = [];
      }
      curShelfCode && tempMap[item.partsCode].push(curShelfCode);
    });
    this.shelfPartsMap = tempMap;
  }
}
